
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';
import { Link } from 'react-router-dom';

export default function PricingSection() {
  const { ref: sectionRef, isVisible } = useScrollAnimation({ threshold: 0.1 });

  const startFeatures = [
    'Atendimento 24/7 via WhatsApp',
    'Follow-up automático',
    'CRM básico integrado',
    'Dashboard com métricas',
    'Agendamento inteligente',
    'Histórico de conversas',
    'Suporte via WhatsApp',
    'Implementação gratuita',
  ];

  const scaleFeatures = [
    'Tudo do Plano Start +',
    'Integração com Instagram',
    'Integração com Facebook Messenger',
    'Disparos em massa ilimitados',
    'Email marketing completo',
    'CRM avançado com segmentação',
    'Múltiplos agentes por nicho',
    'Automações personalizadas',
    'Relatórios avançados',
    'API para integrações',
    'Suporte prioritário',
    'Treinamento exclusivo',
    'Consultoria estratégica mensal',
    'Atualizações prioritárias',
  ];

  return (
    <section id="planos" className="py-16 sm:py-24 bg-dark">
      <div ref={sectionRef} className="max-w-7xl mx-auto px-4 sm:px-6">
        <div 
          className={`text-center mb-10 sm:mb-16 transition-all duration-700 ease-out ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <h2 className="text-2xl sm:text-4xl md:text-5xl font-bold mb-4 sm:mb-6">
            Planos e <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-accent-cyan">Investimento</span>
          </h2>
          <p className="text-sm sm:text-lg text-gray-400 max-w-2xl mx-auto px-2">
            Escolha o plano ideal para o seu negócio. Recorrência no cartão, cancele quando quiser.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 sm:gap-8 max-w-5xl mx-auto">
          <div 
            className={`bg-dark-secondary border-2 border-dark-border rounded-xl sm:rounded-2xl p-6 sm:p-10 transition-all duration-700 ease-out hover:border-primary/50 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
            }`}
            style={{ transitionDelay: '150ms' }}
          >
            <h3 className="text-2xl sm:text-3xl font-bold mb-2">Start</h3>
            <div className="mb-6 sm:mb-8">
              <span className="text-4xl sm:text-5xl font-black text-primary">R$197</span>
              <span className="text-gray-400 text-base sm:text-lg">/mês</span>
            </div>

            <div className="space-y-2 sm:space-y-3 mb-6 sm:mb-8">
              {startFeatures.map((feature, index) => (
                <div key={index} className="flex items-start gap-2 sm:gap-3">
                  <div className="w-4 h-4 sm:w-5 sm:h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-base sm:text-lg text-primary"></i>
                  </div>
                  <span className="text-gray-300 text-xs sm:text-sm">{feature}</span>
                </div>
              ))}
            </div>

            <a
              href="https://pay.kiwify.com.br/U0T83cf"
              target="_blank"
              rel="noopener noreferrer"
              className="block w-full py-3 sm:py-4 border-2 border-primary text-primary hover:bg-primary hover:text-dark font-bold rounded-lg transition-all text-center whitespace-nowrap cursor-pointer text-sm sm:text-base"
            >
              Começar com Start
            </a>
          </div>

          <div 
            className={`relative bg-gradient-to-br from-secondary via-secondary-dark to-navy rounded-xl sm:rounded-2xl p-6 sm:p-10 shadow-2xl shadow-secondary/30 md:scale-105 transition-all duration-700 ease-out border border-secondary/50 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
            }`}
            style={{ transitionDelay: '300ms' }}
          >
            <div className={`absolute -top-3 sm:-top-4 left-1/2 -translate-x-1/2 transition-all duration-500 ${
              isVisible ? 'opacity-100 scale-100' : 'opacity-0 scale-0'
            }`}
            style={{ transitionDelay: '500ms' }}
            >
              <span className="px-4 sm:px-6 py-1.5 sm:py-2 bg-gradient-to-r from-primary to-accent-cyan text-dark font-bold text-xs sm:text-sm rounded-full whitespace-nowrap">
                MAIS COMPLETO
              </span>
            </div>

            <h3 className="text-2xl sm:text-3xl font-bold mb-2 mt-2 sm:mt-0">Scale</h3>
            <div className="mb-6 sm:mb-8">
              <span className="text-4xl sm:text-5xl font-black text-white">R$297</span>
              <span className="text-white/80 text-base sm:text-lg">/mês</span>
            </div>

            <div className="space-y-2 sm:space-y-3 mb-6 sm:mb-8">
              {scaleFeatures.map((feature, index) => (
                <div key={index} className="flex items-start gap-2 sm:gap-3">
                  <div className="w-4 h-4 sm:w-5 sm:h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-base sm:text-lg text-primary"></i>
                  </div>
                  <span className={`text-xs sm:text-sm ${feature.includes('+') || feature.includes('exclusivo') || feature.includes('prioritário') ? 'text-primary font-semibold' : 'text-white/90'}`}>
                    {feature}
                  </span>
                </div>
              ))}
            </div>

            <a
              href="https://pay.kiwify.com.br/rnRjiX5"
              target="_blank"
              rel="noopener noreferrer"
              className="block w-full py-3 sm:py-4 bg-gradient-to-r from-primary to-accent-cyan text-dark hover:opacity-90 font-bold rounded-lg transition-all text-center whitespace-nowrap cursor-pointer text-sm sm:text-base"
            >
              Começar com Scale
            </a>
          </div>
        </div>

        <div 
          className={`text-center mt-8 sm:mt-12 transition-all duration-700 ease-out ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
          style={{ transitionDelay: '450ms' }}
        >
          <p className="text-gray-400 text-xs sm:text-base px-4">
            <strong className="text-white">7 dias de garantia legal</strong> • Cancele quando quiser • Sem multas ou taxas
          </p>
        </div>
        <div className="text-center mt-10">
          <Link
            to="/comparar-planos"
            className="inline-flex items-center gap-2 text-secondary-light hover:text-primary font-medium transition-colors cursor-pointer"
          >
            <span>Ver comparação detalhada dos planos</span>
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}
